// Only drawer opt-in controls use this handler. Cart rendering stays with the theme.
if (!customElements.get('search-drawer-quick-add')) {
  customElements.define('search-drawer-quick-add', class extends HTMLElement {
    constructor() {
      super();
      this.submit = this.submit.bind(this);
    }
    connectedCallback() {
      this.button = this.querySelector('button');
      this.error = this.querySelector('[role="alert"]');
      this.button.addEventListener('click', this.submit);
    }
    disconnectedCallback() {
      this.button.removeEventListener('click', this.submit);
    }
    async submit(event) {
      event.preventDefault();
      if (this.pending || this.button.disabled) return;
      const card = this.closest('product-card');
      this.pending = true;
      this.button.disabled = true;
      this.button.classList.add('loading');
      this.button.setAttribute('aria-busy', 'true');
      this.error.hidden = true;
      try {
        const body = new FormData();
        body.append('id', this.button.dataset.productId);
        body.append('quantity', this.button.dataset.quantity);
        body.append('sections', card.getSectionsToRender().map(section => section.section));
        body.append('sections_url', window.location.pathname);
        const result = await fetch(theme.routes.cart_add_url, {
          method: 'POST',
          headers: {'X-Requested-With': 'XMLHttpRequest', Accept: 'application/javascript'},
          body
        });
        const response = await result.json();
        if (!result.ok || response.status) {
          throw new Error(typeof response.description === 'string' ? response.description : this.dataset.error);
        }
        if (document.getElementById('Cart-Drawer')) {
          OverlayManager.close(document.getElementById('Search-Drawer'));
        }
        card.renderContents(response);
        dispatchCustomEvent('cart:item-added', {
          product: response.hasOwnProperty('items') ? response.items[0] : response
        });
      } catch (error) {
        this.error.textContent = error.message && error.message !== 'Failed to fetch' ? error.message : this.dataset.error;
        this.error.hidden = false;
      } finally {
        this.pending = false;
        this.button.disabled = false;
        this.button.classList.remove('loading');
        this.button.removeAttribute('aria-busy');
      }
    }
  });
}

// Close only the search drawer before the existing quick-view opens above it.
document.getElementById('Search-Drawer')?.addEventListener('click', event => {
  if (event.target.closest('[data-search-drawer-options]')) {
    OverlayManager.close(document.getElementById('Search-Drawer'));
  }
}, {capture: true});
